export const OrderByOptions: Array<ICheckbox> = [
  {value: 'lastest', name: 'جدید‌ترین'},
  {value: 'cheapest', name: 'ارزان‌ترین'},
  {value: 'most_expensive', name: 'گران‌ترین'},
  {value: 'nearest', name: 'نزدیک‌ترین'},
];
